// MLO site images - scraped from mlotax.com
import themisStatue from "@/assets/mlo/themis-statue.webp";
import aboutOffice from "@/assets/mlo/about-office.png";
import personCta from "@/assets/mlo/person-cta.png";
import weightScale from "@/assets/mlo/weight-scale.png";
import gridGraphics from "@/assets/mlo/grid-graphics.png";
import imageUrgency from "@/assets/mlo/image-urgency.webp";
import serviceIconCriminal from "@/assets/mlo/service-icon-criminal.png";
import serviceIconResolution from "@/assets/mlo/service-icon-resolution.png";
import serviceIconCollections from "@/assets/mlo/service-icon-collections.png";
import serviceIconAdditional from "@/assets/mlo/service-icon-additional.png";
import problemIconOwe from "@/assets/mlo/problem-icon-owe.png";
import problemIconGarnishment from "@/assets/mlo/problem-icon-garnishment.png";
import problemIconAudit from "@/assets/mlo/problem-icon-audit.png";
import problemIconUnfiled from "@/assets/mlo/problem-icon-unfiled.png";
import problemIconLien from "@/assets/mlo/problem-icon-lien.png";
import iconStep1 from "@/assets/mlo/icon-step1.png";
import iconStep2 from "@/assets/mlo/icon-step2.png";
import iconStep3 from "@/assets/mlo/icon-step3.png";
import asSeen1Asset from "@/assets/mlo/as-seen-1.webp.asset.json";
import asSeen2Asset from "@/assets/mlo/as-seen-2.webp.asset.json";
import asSeen3Asset from "@/assets/mlo/as-seen-3.webp.asset.json";
import asSeen4Asset from "@/assets/mlo/as-seen-4.webp.asset.json";
import asSeen5Asset from "@/assets/mlo/as-seen-5.webp.asset.json";
import asSeen6Asset from "@/assets/mlo/as-seen-6.webp.asset.json";
import asSeen7Asset from "@/assets/mlo/as-seen-7.webp.asset.json";
import asSeen8Asset from "@/assets/mlo/as-seen-8.webp.asset.json";
const asSeen1 = asSeen1Asset.url;
const asSeen2 = asSeen2Asset.url;
const asSeen3 = asSeen3Asset.url;
const asSeen4 = asSeen4Asset.url;
const asSeen5 = asSeen5Asset.url;
const asSeen6 = asSeen6Asset.url;
const asSeen7 = asSeen7Asset.url;
const asSeen8 = asSeen8Asset.url;
import trustBadge1 from "@/assets/mlo/trust-badge-1.webp";
import trustBadge2 from "@/assets/mlo/trust-badge-2.webp";
import trustBadge3 from "@/assets/mlo/trust-badge-3.webp";
import trustBadge4 from "@/assets/mlo/trust-badge-4.webp";
import logoFavicon from "@/assets/mlo/logo-favicon.png";

export const mloImages = {
  hero: { themisStatue, imageUrgency },
  about: { aboutOffice, personCta, weightScale },
  decorative: { gridGraphics },
  icons: { serviceIconCriminal, serviceIconResolution, serviceIconCollections, serviceIconAdditional, problemIconOwe, problemIconGarnishment, problemIconAudit, problemIconUnfiled, problemIconLien, iconStep1, iconStep2, iconStep3 },
  asSeenOn: [
    { src: asSeen1, name: "The New York Times", width: 263, height: 63 },
    { src: asSeen2, name: "New York Post", width: 224, height: 35 },
    { src: asSeen3, name: "The Philadelphia Inquirer", width: 345, height: 39 },
    { src: asSeen4, name: "CNN", width: 94, height: 53 },
    { src: asSeen5, name: "Fox News", width: 71, height: 59 },
    { src: asSeen6, name: "Fox Business", width: 109, height: 55 },
    { src: asSeen7, name: "CNBC", width: 84, height: 67 },
    { src: asSeen8, name: "MSNBC", width: 199, height: 33 },
  ],
  trustBadges: [
    { src: trustBadge1, name: "American Bar Association (ABA) member" },
    { src: trustBadge2, name: "Delaware State Bar Association (DSBA) member" },
    { src: trustBadge3, name: "Villanova University School of Law alumni" },
    { src: trustBadge4, name: "American Society of Tax Problem Solvers (ASTPS) member" },
  ],
  logo: { logoFavicon },
};
